import { motion } from "framer-motion";
import {
  SiPython, SiJavascript, SiHtml5, SiCss3, SiDocker, SiGithub, SiJenkins,
} from "react-icons/si";
import { BiLogoAws, BiLogoVisualStudio, BiTerminal, BiLogoMicrosoft } from "react-icons/bi";
import { VscAzure } from "react-icons/vsc";

export default function Skills() {
  return (
    <motion.section
      id="skills"
      className="min-h-screen px-6 bg-white dark:bg-gray-900 text-gray-800 dark:text-white flex items-center py-20"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="max-w-6xl w-full">
        <h2 className="text-5xl font-bold mb-6 border-b-4 border-blue-500 inline-block">
          Skills
        </h2>

        {/* Icon Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {/* Programming & Scripting */}
          <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">
              Programming & Scripting
            </h3>
            <div className="flex gap-6 flex-wrap text-4xl text-blue-600 dark:text-blue-500">
              <SiPython title="Python" />
              <SiJavascript title="JavaScript" />
              <SiHtml5 title="HTML5" />
              <SiCss3 title="CSS3" />
              <BiTerminal title="PowerShell / Terminal" />
            </div>
          </div>

          {/* DevOps & Cloud */}
          <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">
              DevOps & Cloud
            </h3>
            <div className="flex gap-6 flex-wrap text-4xl text-blue-600 dark:text-blue-500">
              <BiLogoAws title="AWS" />
              <VscAzure title="Azure" />
              <SiDocker title="Docker" />
              <SiGithub title="GitHub" />
              <SiJenkins title="Jenkins" />
            </div>
          </div>

          {/* Tools & IDEs */}
          <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-lg shadow-md">
            <h3 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-white">
              Tools & IDEs
            </h3>
            <div className="flex gap-6 flex-wrap text-4xl text-blue-600 dark:text-blue-500">
              <BiLogoVisualStudio title="Visual Studio / VS Code" />
              <BiLogoMicrosoft title="Microsoft 365 / Admin" />
              <SiGithub title="GitHub" />
            </div>
          </div>
        </div>

        {/* Descriptive Sections */}
        <div className="space-y-10 text-lg leading-relaxed text-gray-700 dark:text-gray-300">
          <div>
            <h3 className="text-xl font-semibold text-blue-700 dark:text-blue-400 mb-2">
              Passionate About
            </h3>
            <ul className="list-disc list-inside">
              <li>Cloud architecture on AWS and Azure</li>
              <li>Infrastructure as Code: Terraform, Bicep, CloudFormation</li>
              <li>Automated provisioning, networking, and security policies</li>
              <li>Agile/DevOps practices and continuous improvement</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-blue-700 dark:text-blue-400 mb-2">
              Proficient In
            </h3>
            <ul className="list-disc list-inside">
              <li>Cloud administration and identity (AD/Azure AD)</li>
              <li>Linux & Windows Server administration</li>
              <li>Web basics for cloud frontends (HTML/CSS/JS)</li>
              <li>Collaboration & ITSM tools (Jira, Teams, etc.)</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-semibold text-blue-700 dark:text-blue-400 mb-2">
              Knowledgeable About
            </h3>
            <ul className="list-disc list-inside">
              <li>Python, JavaScript, PowerShell</li>
              <li>CI/CD: GitHub Actions, Jenkins, Azure DevOps, CodePipeline</li>
              <li>Containers/Serverless: Docker, ECS, Lambda, Azure Functions</li>
            </ul>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
